import { Search, Users } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, EmptyState, ErrorState, Input, Skeleton } from '@/components/ui';
import { formatNumber } from '@/lib/utils';

import { useAdminUsers } from './admin-actions-api';
import { UserList } from './user-list';

/** משתמשים בכל העסקים: חיפוש באימייל או בשם, ופעולות תמיכה. */
export function UsersSection() {
  const { t } = useTranslation('admin');
  const [input, setInput] = useState('');
  const [search, setSearch] = useState('');

  // חיפוש אחרי הפסקת הקלדה — כל בקשה נרשמת ביומן.
  useEffect(() => {
    const id = setTimeout(() => setSearch(input.trim()), 350);
    return () => clearTimeout(id);
  }, [input]);

  const q = useAdminUsers(search);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <label className="relative block w-full max-w-sm">
          <span className="sr-only">{t('users.search')}</span>
          <Search
            className="pointer-events-none absolute start-3 top-1/2 size-4 -translate-y-1/2 text-fg-subtle"
            aria-hidden
          />
          <Input
            type="search"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={t('users.searchPlaceholder')}
            maxLength={100}
            className="ps-9"
          />
        </label>
        {q.data ? (
          <p className="text-xs text-fg-muted">
            {q.data.total > q.data.rows.length
              ? t('businesses.shown', {
                  shown: formatNumber(q.data.rows.length),
                  total: formatNumber(q.data.total),
                })
              : t('users.count', { count: q.data.total })}
          </p>
        ) : null}
      </div>
      <Card>
        <CardContent>
          {q.isError ? (
            <ErrorState error={q.error} onRetry={() => void q.refetch()} />
          ) : !q.data ? (
            <div className="space-y-2">
              {Array.from({ length: 5 }, (_, i) => (
                <Skeleton key={i} className="h-12 w-full" />
              ))}
            </div>
          ) : q.data.rows.length === 0 ? (
            <EmptyState icon={Users} title={t('users.empty')} />
          ) : (
            <UserList users={q.data.rows} showBusiness />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
